import { useEffect } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

import {
  AccionDetalle,
  IInitialState,
  TipoAccionDetalle,
} from '../../Shared/data/FormReducer';
import { Tr4inerContainedButton } from '../../Utils/Button';

import bienvenidoIcon from '../../Shared/Images/bienvenido-icon.png';
import LogoFit4Challenge from '../../Shared/Images/fit4challenge.png';

import styles from './Styles/stylesF01.module.css';


interface IForm01 {
  state: IInitialState;
  dispatch: React.Dispatch<AccionDetalle>;
}

const Form01: React.FC<IForm01> = (props) => {
  const matches = useMediaQuery('(max-width: 650px)');

  const handleNext = () => {
    //scroll hacia arriba con smooth
    window.scrollTo(0, 0);
    props.dispatch({
      type: TipoAccionDetalle.CHANGE_NFORM,
      payload: props.state.nForm + 1,
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="mb-3 container mt-5" style={{ height: matches ? '' : '70vh' }}>
        <div className={`flex justify-center ${matches ? 'mb-4' : 'mb-5'}`}>
          <img src={LogoFit4Challenge} alt="logo" style={{ height: '70px' }} />
        </div>
        <div className="container form-macro" style={{ height: '100%' }}>
          <div className={`m-4 ${styles.container}`} style={{ height: '100%' }}>
            <div
              className="flex items-center"
              style={{
                gap: '1rem',
                justifyContent: matches ? '' : 'center',
              }}
            >
              {matches && (
                <img src={bienvenidoIcon} alt="icon" style={{ width: '1.5rem' }} />
              )}
              <h3
                style={{
                  margin: 0,
                  fontWeight: 'bold',
                  textShadow: '0px .2px 2px rgba(0,0,0,0.6)',
                  fontSize: matches ? '1rem' : '2rem',
                }}
              >
                ¡Te damos la bienvenida a tu transformación!
              </h3>
            </div>
            {/* <h1>¡Bienvenido {props.state.nombre}!</h1> */}
            <div className={`m-2 ${styles.p}`}>
              Este es el primer paso de tu cambio. Ahora personalizaremos tu plan para que logres el mejor físico 
              de tu vida en los próximos 90 días. Completa este test y recibirás exactamente 
              lo que necesitas para empezar con todo.
            </div>
            <Tr4inerContainedButton
              variant="contained"
              size="large"
              sx={{
                fontWeight: 'bold',
                textTransform: 'capitalize',
                fontSize: '1.2rem',
              }}
              onClick={handleNext}
            >
              {`¡PERSONALIZAR MI PLAN AHORA!`}
            </Tr4inerContainedButton>
          </div>
        </div>
        {/* <div
          className="row d-flex justify-content-center"
          style={{ width: '100%', margin: 0 }}
        >
          <div className="col-6 justify-content-center">
            <Tr4inerContainedButton
              variant="contained"
              size="large"
              sx={{
                textTransform: 'uppercase',
              }}
              onClick={handleNext}
            >
              {`¡Empecemos!`}
            </Tr4inerContainedButton>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default Form01;
